import { useState } from "react";
import { Loader2, RefreshCw, Clock } from "lucide-react";
import { Button } from "./ui/button";
import { CancelBuildButton } from "./CancelBuildButton";
import { ProgressBar } from "./BuildProgressBar";
import { BuildStageList } from "./BuildStageList";
import { BuildHeadline } from "./BuildHeadline";
import { useBuildClock } from "../hooks/useBuildClock";

const BuildActions = ({ showContinue, waiting, onExtend, onRetry, onCancel }) => {
  const [extending, setExtending] = useState(false);
  const extend = async () => {
    setExtending(true);
    await onExtend?.();
    setExtending(false);
  };
  return (
    <div className="flex flex-wrap gap-3">
      {showContinue && (
        <Button data-testid="build-continue-btn" onClick={extend} disabled={extending} className="rounded-full h-11 gap-2 font-bold">
          {extending ? <Loader2 className="h-4 w-4 animate-spin" /> : <Clock className="h-4 w-4" />} Continue · +15 min
        </Button>
      )}
      {waiting && (
        <Button variant="outline" className="rounded-full h-11 gap-2" onClick={onRetry} data-testid="build-retry-now-btn">
          <RefreshCw className="h-4 w-4" /> Try again now
        </Button>
      )}
      {onCancel && <CancelBuildButton onCancel={onCancel} />}
    </div>
  );
};

// Active states: views (AI side renders), queued/building (sculpt) and waiting (auto-retry).
export const BuildRunningPanel = ({ creation, onRetry, onCancel, onExtend }) => {
  const waiting = creation.build_status === "waiting";
  const viewsStage = creation.build_status === "views";
  const { elapsed, progress, retryIn } = useBuildClock(creation);
  const showContinue = !!onExtend && !waiting && !viewsStage && progress >= 0.75;

  return (
    <>
      <BuildHeadline creation={creation} waiting={waiting} viewsStage={viewsStage} retryIn={retryIn} />
      <ProgressBar creation={creation} waiting={waiting} elapsed={elapsed} />
      <BuildStageList creation={creation} />
      <BuildActions showContinue={showContinue} waiting={waiting} onExtend={onExtend} onRetry={onRetry} onCancel={onCancel} />
    </>
  );
};
